import gsap from 'gsap';

function Modal() {

  var elBtnModal = document.querySelectorAll('.btn-modal--booking-table a');
  if (elBtnModal) {
    var elModalBookingTable = document.querySelector('.modal--booking-table');

    // CLOSE
    function onClickClose(evt) {
      gsap.to(elModalBookingTable, {autoAlpha: 0});
    }

    var elClose = elModalBookingTable.querySelectorAll('.modal__bg, .modal__btn-close');
    const nbClose = elClose.length;
    for(let i = 0; i < nbClose; ++i) {
      elClose[i].addEventListener('click', onClickClose);
    }

    // OPEN
    function onClickBtn(evt) {
      evt.preventDefault();
      gsap.to(elModalBookingTable, {autoAlpha: 1});
      return false;
    }

    const nBtn = elBtnModal.length;
    for(let i = 0; i < nBtn; ++i) {
      elBtnModal[i].addEventListener('click', onClickBtn);
    }
  }
}

export default Modal;
